import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FieldsetModule } from 'primeng/fieldset';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { SociosAdicionarComponent } from './socios-adicionar/socios-adicionar.component';
import { SociosListagemComponent } from './socios-listagem/socios-listagem.component';
import { SociosDetalhesComponent } from './socios-detalhes/socios-detalhes.component';
import { SociosEditarProlaboreComponent } from './socios-editar-prolabore/socios-editar-prolabore.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { TabViewModule } from 'primeng/tabview';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';

@NgModule({
  declarations: [
    SociosAdicionarComponent,
    SociosListagemComponent,
    SociosDetalhesComponent,
    SociosEditarProlaboreComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    ConfirmDialogModule,
    DropdownModule,
    FormsModule,
    TooltipModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FieldsetModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    TabViewModule,
    SpinnerServiceComponent,
    InputTextareaModule,
    CalendarModule,
    ToolbarSearchComponent
  ],
  exports: [
    SociosAdicionarComponent,
    SociosListagemComponent,
    SociosDetalhesComponent,
    SociosEditarProlaboreComponent,
    RadioButtonModule,
    InputNumberModule
  ],
})
export class SociosModule { }